import { useUserRepository } from '@/repositories/useUserRepository';
import { FirebaseAuthenticationService } from '@/services/authentication/firebaseAuthenticationService';
import { AuthenticationService } from '@/services/authentication/interfaces';

import { useLoggingService } from '../logging/composable';

let authenticationService: AuthenticationService | null = null;

export function useAuthenticationService(options?: {
  serviceInstance?: AuthenticationService;
}): AuthenticationService {
  if (options?.serviceInstance) {
    authenticationService = options.serviceInstance;
    return options.serviceInstance;
  }

  if (!authenticationService) {
    authenticationService = new FirebaseAuthenticationService(useLoggingService(), () =>
      useUserRepository(),
    );
  }
  return authenticationService;
}
